import { render, staticRenderFns } from "./IconSvgSnmmiFollowUs.vue?vue&type=template&id=7d08c929&scoped=true&"
import script from "./IconSvgSnmmiFollowUs.vue?vue&type=script&lang=js&"
export * from "./IconSvgSnmmiFollowUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d08c929",
  null
  
)

export default component.exports